<template>
  <div class="respo">
      <div class="banner">
        <div class="banner-content clearfix">
          <img class="banner-textL fl" src="./banner-text.png" alt="" >
          <div class="oneByOne fr">
            <!-- <h1 id="htext" style="display: none;">孟子云：“达则兼济天下”。</h1>
            <p id="summaryText" style="display: none;">在亚商，我们一直坚信一个成功的企业除了给股东和投资人创造优异的投资回报，更重要的是如何将所积累下来的资源和专业才能用于回报社会，从而给后代留下一个更美好的世界。这正是我们多年以来坚持不懈地在全国积极参与并发起多项公益活动的动力。</p>
            <h1 id="h1" class="fzhl"></h1>
            <p id="summary" class="FZfs"></p> -->
            <img id="h1text" class="h1text" src="./title.png" alt="">
            <img id="fadeInText" class="fadeInText" src="./fadeInText_03.png" alt="">
              <!-- <transition name="fade">
                <img class="fadeInText" v-show="fadeInText" src="./fadeInText_03.jpg" alt="">
              </transition> -->
          </div>
        </div>
      </div>
      <div class="content-box">
          <img class="bgLeft" src="./bg-pic2.png" alt="">
          <img class="bgRight" src="./bg-pic1.png" alt="">
          <img class="bgBottom" src="./bg-pic3.png" alt="">
          <div class="main-content">
              <div class="mt140" v-for="news in newsList" :key="news.id">
                <p class="title">{{news.title}}</p>
                <div class="tips">
                  <p>发布时间：<span>{{news.time}}</span></p>
                </div>
                <div class="clearfix">
                  <div class="newsPic" :class="{fl: news.id%2 == 0, fr:news.id%2!=0}" >
                    <img :src="news.newsPic" alt="">
                  </div>
                  <div class="info-detail" :class="{fr: news.id%2 == 0, fl:news.id%2!=0}">
                    <p class="text" v-for="(item,index) in news.details" :key="index">{{item}}</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      <go-top></go-top>
  </div>
</template>

<script>
import goTop from "../../common/go-top.vue";
export default{
  name: 'Responsibility',
  components: {
    goTop
  },
  data(){
    return {
      fadeInText: false,
      // h1Text: '孟子云：“达则兼济天下”。',
      // summary: '在亚商，我们一直坚信一个成功的企业除了给股东和投资人创造优异的投资回报，更重要的是如何将所积累下来的资源和专业才能用于回报社会，从而给后代留下一个更美好的世界。这正是我们多年以来坚持不懈地在全国积极参与并发起多项公益活动的动力。',
      newsList: [
        {
          id: 0,
          title: '「亚商正能量」初春四月 亚商送上暖心菜',
          time: '2022年4月',
          newsPic: require('./banVegetables.jpg'),
          details: [
            '从四月初上海进入疫情攻坚阶段，亚商的员工在居家办公的同时，各家的食品配给是否足够也是亚商一直关心的。亚商智讯发起，亚商集团通过线上沟通，达成为每一位亚商员工送上暖心菜。',
          ]
        },
        {
          id: 1,
          title: '「亚商正能量」防汛救灾，风雨同担，正经塾"豫"您一起',
          time: '2021年7月',
          newsPic: require('./zhuliHN.jpg'),
          details: [
            '一方有难，八方支援！河南多地由极端强降雨造成的严重灾情也令天南海北的正经塾塾生企业家们时刻牵挂忧心，他们第一时间及时响应，建立起向灾区捐赠的微信工作小组群。',
            '在亚商集团、掌门人正经塾创始人陈琦伟的带领下，以白象集团总经理姚进、上海麟众投资管理有限公司董事长杨志远、上海极承文化传媒有限公司董事长荣建钧、湖南景达生物工程有限公司董事长陈玉、上海网域网科技有限公司CEO肖确伟、北京中诚胜合投资管理中心董事长付昂、上海福美泰生物技术有限公司总经理陈友梅等为代表的塾生们积极捐赠，紧急采购了防汛救灾及生活急需的物资，陆续发往受灾地区，助力防汛抢险及灾后重建工作。'
          ]
        },
        {
          id: 2,
          title: '「亚商助力」亚商集团董事长陈琦伟教授携企业员工助力2018年上海光明半程马拉松赛',
          time: '2018年4月',
          newsPic: require('./banma1.jpg'),
          details: [
            '2018年4月22日，跑动全城的上海国际半程马拉松赛事拉开帷幕，亚商的跑团成员在享受跑步的同时也不忘完成我们的公益使命。参加公益马拉松一举两得自然是亚商跑团的首选。',
            '本次半马赛事跑团中领队的，自然是亚商集团董事长陈琦伟教授，31度的上海给亚商跑团带来了不少压力，跑程中不断看到有参赛者因酷热发生抽筋，微脱水等状况。所幸亚商跑团不是假把式，人人都跑完全程。陈琦伟教授跑出了2小时13分钟成绩。事后问及，陈教授对成绩还不太满意，看来下次半马亚商跑团还要全力以赴~',
            '各位热爱跑步的朋友们，跑完之后记得一定要补充水分和拉伸哦~爱跑步 爱亚商。'
          ]
        },
        {
          id: 3,
          title: '「亚商公益」让中国大马哈鱼，鲟鳇鱼回家',
          time: '2016年12月',
          newsPic: require('./mdh.jpg'),
          details: [
            '黑龙江省从来都是以广袤无垠的黑土地、连绵起伏的大森林、波浪翻滚的大江河以及丰富多样的动植物而全国知名。这是黑龙江省与生俱来的珍贵自然资源和自然资本。如果用国际的“自然资本（Nature Capital）”的标准来衡量，黑龙江在此方面的优势是可以排在中国前列的。一条黑龙江是中国难得的全境流经一个省的大江，保护好黑龙江这条宝贵的尚未污染和破坏的河流及水生动物植物应该是着力之处。',
            '亚商集团与一批志同道合的企业家好友共同发起资助了黑龙江永续自然资源保护基金会作为黑龙江省内第一家正式成立的生态环境保护基金会，希望能成为黑龙江省生态环境保护和恢复的新生力量。这项公益活动也得到了黑龙江省政府主要领导的直接支持，和人民日报等主流媒体的关注和报道。',
          ]
        },
        {
          id: 4,
          title: '「亚商公益」亚商集团联席总裁张琼女士资助么龙希望小学',
          time: '2018年4月',
          newsPic: require('./xwxx.jpg'),
          details: [
            '亚商集团联席总裁张琼女士自2006年起，与马关县教育局在昆明签订协议，向马关县夹寒箐镇么龙村捐资建设了夹寒箐镇么龙希望小学。并在至今的十多年间保持互动与往来。',
            '夹寒箐镇属于边境民族贫困乡镇，全镇3万人口中就有2万多生活在贫困线下。么龙村小学由于长期没有资金投入，校舍已成为危房，学生就学环境十分艰苦。',
            '在张琼女士的捐赠款帮助下，校方着手开始重建校舍和学生宿舍，改善学习硬件设备和食堂伙食。张琼女士还为小同学们订购课本和读物，送往夹寒箐镇。充实么龙希望小学的图书馆。每次去到小学和小同学们相处，关心学生生活情况，这小小图书馆里的每本书都被翻阅了几百遍，感受到孩子们热爱学习的心。',
          ]
        }
      ],

    }
  },
  mounted(){
    this.$nextTick(function(){
      this.textOneByOne();
    });
  },
  methods: {
    textOneByOne(){
      $('#h1text').animate({
        opacity: 1
      }, 800, function(){
        $('#fadeInText').animate({
          right: '0px',
          opacity: 1,
        }, 900);
      });

      // let _h1 = document.getElementById('h1');
      // let _summaryText = document.getElementById('summaryText');
      // var _hText = document.getElementById('htext');
      // let _summary = document.getElementById('summary');
      // let i = 0;
      // var timer = setInterval(function(){
      //   _h1.innerHTML = _hText.innerHTML.substring(0, i);
      //   i++;
      //   console.log();
      //   if(_h1.innerHTML == _hText.innerHTML){
      //     clearInterval(timer);
      //     let j = 0;
      //     let timer1 = setInterval(function(){
      //       _summary.innerHTML = _summaryText.innerHTML.substring(0, j);
      //       j++;
      //       if(_summary.innerHTML == _summaryText.innerHTML){
      //         clearInterval(timer1);
      //       }
      //     },50);
      //   }
      // }, 90);
    }
  }
}
</script>

<style scoped>
.respo{
  min-width: 1200px;
  background: #fff;
}
.banner{
  width: 100%;
  height: 495px;
  background: url('./bannerBG.jpg') no-repeat center 0;
  background: cover;
}
.respo .banner-content{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  /* text-align: left; */
}
.respo .oneByOne{
  position: absolute;
  top: 188px;
  right: 40px;
  width: 580px;
  height: 250px;
  text-align: left;
}
.respo .banner-textL{
  margin-left: 25px;
}
.respo .content-box{
  position: relative;
  padding-top: 80px;
  padding-bottom: 115px;
}
.respo .content-box .bgLeft{
  position: absolute;
  bottom: 700px;
  left: 0;
}
.respo .content-box .bgRight{
  position: absolute;
  bottom: 1100px;
  right: 0;
}
.respo .content-box .bgBottom{
  position: absolute;
  bottom: 0;
  right: 0;
}
.main-content{
  width: 1200px;
  margin: 0 auto;
  padding: 0 80px;
  box-sizing: border-box;
  z-index: 2;
}
.main-content .mt140{
  margin-bottom: 140px;
}
.main-content .newsPic{
  width: 432px;
  height: 282px;
}
.main-content .newsPic img{
  width: 100%;
}
.main-content .info-detail{
  width: 570px;
  /* padding: 0px 20px; */
}
.main-content .title{
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-bottom: 15px;
  color: #333;
}
.main-content .title,.main-content .tips{
  text-align: left;
}
.main-content .tips{
  margin-bottom: 40px;

}
.main-content .tips p{
  font-size: 14px;
  margin-bottom: 4px;
}
.main-content .tips span{
  color: #003B83;
  font-weight: 600;
}
.main-content .info-detail .text{
  text-align: justify;
  line-height: 24px;
  color: #000;
  font-size: 18px;
  margin-bottom: 15px;
}
.main-content .pic{
  width: 100%;
  /* height: 182px; */
  margin-bottom: 24px;
  /* overflow: hidden; */
}
.h1text{
  margin-left: -28px;
  margin-bottom: 25px;
  opacity: 0;
}
.fadeInText{
  width: 570px;
  position: relative;
  right: 20px;
  top: 0;
  opacity: 0;
}
/* .fade-enter-active, .fade-leave-active {
  transition: all .8s ease;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
} */
</style>




// WEBPACK FOOTER //
// src/components/responsibility/Responsibility.vue